import { render, staticRenderFns } from "./ModalMinibar.vue?vue&type=template&id=6e38583d&"
import script from "./ModalMinibar.vue?vue&type=script&lang=js&"
export * from "./ModalMinibar.vue?vue&type=script&lang=js&"
import style0 from "./ModalMinibar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports